import { useContext, useMemo } from 'react'
import { CutterContext } from '../../contexts/CutterContext'
import { Position } from '../../../types'

export function useTimelineTickPositions(width: number) {
  const {
    visibleRange,
    audio: { length },
  } = useContext(CutterContext)

  const [from, count, step] = useMemo(() => {
    const ticksCount = Math.round(width / 150)
    const tickLength = length / ticksCount
    const visibleLength = visibleRange[1] - visibleRange[0]

    const roundedRatio = Math.pow(2, Math.trunc(Math.log2(length / visibleLength)))

    const step = Math.round(tickLength / roundedRatio)
    if (step === 0) {
      return [0, 0, 0]
    }
    const from = Math.round(visibleRange[0] / step) * step
    const count = Math.trunc(visibleLength / step)

    return [from, count, step]
  }, [width, visibleRange, length])

  return useMemo(() => {
    const positions: Position[] = []

    for (let i = 0; i <= count; i++) {
      positions.push(from + i * step)
    }

    return positions
  }, [from, count, step])
}
